import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//guards
import { JwtAuthGuard } from './_guards/jwt-auth.guard';
import { JwtAuthClientGuard } from './_guards/jwt-auth-client.guard';
import { JwtAuthTransporteurGuard } from './_guards/jwt-auth-transporteur.guard';
//components
import { ClientComponent } from './_components/client/client.component';
import { ClientDashboardComponent } from './_components/client/client-dashboard/client-dashboard.component';
import { ContactComponent } from './_components/contact/contact.component';
import { CompanyComponent } from './_components/company/company.component';
import { DemandComponent } from './_components/demand/demand.component';
import { OfferComponent } from './_components/offer/offer.component';
import { PlanningComponent } from './_components/planning/planning.component';
import { TransportDetailsComponent } from './_components/transport-details/transport-details.component';
import { DeliveryDetailsComponent } from './_components/delivery-details/delivery-details.component';
import { ClientPlanningCreationComponent } from './_components/client-planning-creation/client-planning-creation.component';
import { UserComponent } from './_components/user/user.component';
import { WarehouseComponent } from './_components/warehouse/warehouse.component';
import { CityComponent } from './_components/city/city.component';
import { LoginComponent } from './_components/login/login.component';
import { DashboardComponent } from './_components/dashboard/dashboard.component';
import { TransporteurComponent } from './_components/transporteur/transporteur.component';
import { PageNotFoundComponent } from './_components/page-not-found/page-not-found.component';

import { NavigationService } from './_services/navigation.service';
import { ClientIncidentsComponent } from './_components/client/client-incidents/client-incidents.component';
import { ClientNewPlanningComponent } from './_components/client/client-new-planning/client-new-planning.component';
import { ClientTasksComponent } from './_components/client/client-tasks/client-tasks.component';
import { DevisComponent } from './_components/devis/devis.component';
import { ConfigComponent } from './_components/config/config.component';
import { TransportInterestComponent } from './_components/transport-interest/transport-interest.component';

const routes: Routes = [
  { path: '', redirectTo: 'planning', pathMatch: 'full'},
  { path: "login", component: LoginComponent },
  { path: "transport-details", component: TransportDetailsComponent },
  { path: "delivery-details", component: DeliveryDetailsComponent },
  { path: "transport-interest/:id/:token", component: TransportInterestComponent},
  { path: "client-planning-creation", component: ClientPlanningCreationComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [JwtAuthGuard] },
  { path: "contacts", component: ContactComponent, canActivate: [JwtAuthGuard] },
  { path: "companies", component: CompanyComponent, canActivate: [JwtAuthGuard] },
  { path: "demands", component: DemandComponent, canActivate: [JwtAuthGuard] },
  { path: "offers", component: OfferComponent, canActivate: [JwtAuthGuard] },
  { path: "planning", component: PlanningComponent, canActivate: [JwtAuthGuard] },
  { path: 'users', component: UserComponent, canActivate: [JwtAuthGuard] },
  { path: 'warehouses', component: WarehouseComponent, canActivate: [JwtAuthGuard] },
  { path: 'cities', component: CityComponent, canActivate: [JwtAuthGuard] },
  //espace transporteur
  { path: 'transporteur', component: TransporteurComponent, canActivate: [JwtAuthTransporteurGuard] },
  //espace client, pas le meme authGuard.
  { path: "client", component: ClientComponent, canActivate: [JwtAuthClientGuard] },
  { path: "client-dashboard", component: ClientDashboardComponent, canActivate: [JwtAuthClientGuard] },
  { path: "client-incidents", component: ClientIncidentsComponent, canActivate: [JwtAuthClientGuard] },
  { path: "client-new-planning", component: ClientNewPlanningComponent, canActivate: [JwtAuthClientGuard] },
  { path: "client-tasks", component: ClientTasksComponent, canActivate: [JwtAuthClientGuard] },
  { path: "client-planning-creation", component: ClientPlanningCreationComponent, canActivate: [JwtAuthClientGuard] },
  { path: "devis", component: DevisComponent, canActivate: [JwtAuthClientGuard] },
  { path: "config", component: ConfigComponent, canActivate: [JwtAuthGuard] },
  { path: "**", component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [JwtAuthGuard, JwtAuthClientGuard,JwtAuthTransporteurGuard, NavigationService]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// /usr/src/app/src/app/app-routing.module.ts